import { fileApi } from '@/core/api/file'

export const {
  useGeneratePresignedUrlMutation,
  useUploadToAWSMutation,
  useAddFileMutation,
  useDeleteFilesMutation,
  useUpdateFilenameMutation,
  useGetFileUrlByKeyQuery,
  useFindFilesByObjectQuery,
  useCreateUploadGrantMutation,
  useUploadFileWithGrantMutation,
} = fileApi
